import {Component, ViewChild} from "@angular/core";
import {NavController, Slides} from 'ionic-angular';
import {ResultsPage} from '../results/results';

@Component({
  templateUrl: 'build/pages/questions/questions.html'
})

export class QuestionsPage {
  constructor(private nav: NavController) {
    this.nav = nav;
  }

  insideOutside = 0;
  conditions = 0;
  skinCondition = 0;
  skinAdditional = 0;

  glovesVal = 0;
  footVal = 0;
  protectWhereVal = 0;
  protectWhatVal = 0;
  restoreVal = 0;

  environmentQuestions1 = '';
  environmentQuestions2 = '';

  skinAdditional1 = '';
  skinAdditional2 = '';
  skinAdditional3 = '';

  activeSlide = 0;
  productType = 'protect';
  currentPosition = 'position0';
  envImg = '';
  skinAddImg1 = '';
  skinAddImg2 = '';
  hiddenSlide = '';

  nextPage(){
    this.nav.setRoot(ResultsPage, {gloves: this.glovesVal, foot: this.footVal, protectWhere: this.protectWhereVal, protectWhat: this.protectWhatVal, restore: this.restoreVal}, {animate: true, direction: 'forward'});
  }

  SliderOptions = {
    initialSlide: 0,
    onlyExternal: true
  };

  @ViewChild('mySlider') slider: Slides;

  // onSlideChanged() {
  //   let currentIndex = this.slider.getActiveIndex();
  //   //console.log("Current index is", currentIndex);
  //   this.currentPosition = 'position' + currentIndex;
  // }

  slidePrev() {
    this.slider.slidePrev();
    this.activeSlide--;

    if(this.protectWhereVal < 20) {
      if (this.activeSlide <= 3) {
        this.productType = 'protect';
      } else {
        this.productType = 'restore';
      }
    } else {
      if (this.activeSlide <= 4) {
        this.productType = 'protect';
      } else {
        this.productType = 'restore';
      }
    }

    this.currentPosition = 'position' + this.activeSlide;
    //console.log(this.currentPosition);
  }

  slideNext() {
    this.activeSlide++;

    if(this.protectWhereVal < 20) {
      if (this.activeSlide <= 3) {
        this.productType = 'protect';
      } else {
        this.productType = 'restore';
      }
    } else {
      if (this.activeSlide <= 4) {
        this.productType = 'protect';
      } else {
        this.productType = 'restore';
      }
    }

    this.currentPosition = 'position' + this.activeSlide;
    //console.log(this.currentPosition);
  }

  glovesAnswer(val) {
    this.slider.slideNext();
    this.glovesVal = val;

    this.slideNext();
  }

  footAnswer(val) {
    this.slider.slideNext();
    this.footVal = val;

    this.slideNext();
  }

  insideOutsideAnswer(val, loc) {
    if(loc === 1) {
      this.environmentQuestions1 = 'Sunny';
      this.environmentQuestions2 = 'Cold';

      this.envImg = './img/icon_p-sunny.svg';
    } else {
      this.environmentQuestions1 = 'Welding';
      this.environmentQuestions2 = 'Refrigeration';

      this.envImg = './img/icon_p-welding.svg';
    }

    this.slider.slideNext();
    this.insideOutside = val;
    this.protectWhereVal = (this.insideOutside + this.conditions);

    this.slideNext();
  }

  conditionsAnswer(val) {
    this.conditions = val;
    this.protectWhereVal = (this.insideOutside + this.conditions);

    if(this.protectWhereVal < 20) {
      this.hiddenSlide = 'slide-hidden';
    } else {
      this.hiddenSlide = '';
    }

    this.slider.slideNext();
    this.slideNext();
  }

  protectWhatAnswer(val) {
    this.slider.slideNext();
    this.protectWhatVal = val;

    this.slideNext();
  }

  skinConditionAnswer(val, add) {
    this.skinCondition = val;
    this.restoreVal = (this.skinCondition + this.skinAdditional);

    if (add === 2) {
      this.skinAdditional1 = 'Do you have sensitive hands?';
      this.skinAdditional2 = 'Yes';
      this.skinAdditional3 = 'No';

      this.skinAddImg1 = './img/icon_r-yes.svg';
      this.skinAddImg2 = './img/icon_r-no.svg';

      this.slider.slideNext();
    } else if (add === 1) {
      this.skinAdditional1 = 'Where will the cream be used?';
      this.skinAdditional2 = 'Hands';
      this.skinAdditional3 = 'All Over Body';

      this.skinAddImg1 = './img/icon_r-hands.svg';
      this.skinAddImg2 = './img/icon_r-body.svg';

      this.slider.slideNext();
    } else {
      this.nextPage();
    }

    this.slideNext();
  }

  skinAdditionalAnswer(val) {
    this.skinAdditional = val;
    this.restoreVal = (this.skinCondition + this.skinAdditional);

    this.nextPage();
  }

}
